import css from 'styled-jsx/css'

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/vars';
  @import 'src/common/styling/_mixins-scss/rem';

  .PartnershipClientAccountPage__table {
    margin-top: rem(25px);
    @include respond-to(sm) {
      margin-top: rem(10px);
    }
    :global(.NoItemsPanel) {
      box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.06);
      height: 200px !important;
      min-height: auto !important;
      img {
        margin-bottom: 25px !important;
      }
      h3 {
        font-size: rem(16px) !important;
        margin-bottom: 0 !important;
        line-height: rem(19px) !important;
      }
    }
  }

  .PartnershipClientAccountPage__top-line {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    min-height: 50px;
    @include respond-to(sm) {
      min-height: 54px;
    }
    .PageTabs {
      width: auto;
      @include respond-to(sm) {
        order: 0;
        margin-bottom: 15px;
      }
    }
  }

  .PartnershipClientAccountPage__date {
    @include respond-to(xs) {
      width: 100%;
      order: 1;
    }
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .PartnershipClientAccountPage__table {
      :global(.NoItemsPanel) {
        :global(img) {
          width: 100px !important;
        }
      }
    }
  }
`

const getDynamicStyles = ({ colors, border }) => {
  return css.global`
    .PartnershipClientAccountPage__table {
      .NoItemsPanel {
        background-color: ${colors.white.hex};
        border-radius: ${border.radius};
      }
    }
  `
}

export { staticStyles, getDynamicStyles }
